import React, { useState, useEffect } from "react";
import { FaBars } from "react-icons/fa";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";
import {
  Nav,
  NavbarContainer,
  NavLogo,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLinks,
  BtnWrapper,
  IconWrapper,
  IconLink,
} from "./NavbarStyles";
import { Btn2 } from "../Globalstyles/GlobalStyles";
import { BsCodeSlash } from "react-icons/bs";
import { SiGithub } from "react-icons/si";
import { FaLinkedin, FaTwitterSquare, FaFacebookSquare } from "react-icons/fa";
import { VscLink } from "react-icons/vsc";
import { FiInstagram } from "react-icons/fi";
import logo from "../../my-logo.svg";
import Fade from "react-reveal";
import Flip from "react-reveal";

function Navbar({ toggle }) {
  const [scrollNav, setScrollNav] = useState(false);
  const changeNav = () => {
    if (window.scrollY > 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeNav);
  }, []);
  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <>
      <Nav scrollNav={scrollNav}>
        <NavbarContainer>
          <Fade top>
            <NavLogo onClick={toggleHome} to="/">
              {" "}
              <img
                style={{ width: "1rem", height: "auto", marginRight: "10px" }}
                src={logo}
                alt="logo"
                srcset=""
              />
              Nobert.dev
            </NavLogo>
          </Fade>

          <MobileIcon onClick={toggle}>
            <FaBars />
          </MobileIcon>
          <Fade top>
            <NavMenu>
              <NavItem>
                <NavLinks
                  to="home"
                  smooth={true}
                  duration={500}
                  exact="true"
                  spy="true"
                  offset={-80}
                >
                  Home
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to="about"
                  smooth={true}
                  duration={500}
                  exact="true"
                  spy="true"
                  offset={-80}
                >
                  About
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to="skills"
                  smooth={true}
                  duration={500}
                  exact="true"
                  spy="true"
                  offset={-80}
                >
                  Skills
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to="projects"
                  smooth={true}
                  duration={500}
                  exact="true"
                  spy="true"
                  offset={-80}
                >
                  Projects
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to="contact"
                  smooth={true}
                  duration={500}
                  exact="true"
                  spy="true"
                  offset={-80}
                >
                  Contact
                </NavLinks>
              </NavItem>
            </NavMenu>

            <IconWrapper>
              <IconLink href="https://github.com/NOBERT167" target="_blank">
                <SiGithub />
              </IconLink>
              <IconLink
                href="https://www.linkedin.com/mwlite/in/langat-kipkoech-nobert-ab44661ba"
                target="_blank"
              >
                <FaLinkedin />
              </IconLink>
              <IconLink href="https://twitter.com/Darkcode1999" target="_blank">
                <FaTwitterSquare />
              </IconLink>
              <IconLink
                href="https://www.instagram.com/nobert.dev/"
                target="_blank"
              >
                <FiInstagram />
              </IconLink>
              <IconLink
                href="https://www.facebook.com/nobert.langat.12"
                target="_blank"
              >
                <FaFacebookSquare />
              </IconLink>
              <IconLink href="https://bio.link/nobertdev" target="_blank">
                <VscLink />
              </IconLink>
            </IconWrapper>
          </Fade>
        </NavbarContainer>
      </Nav>
    </>
  );
}

export default Navbar;
